import _ from 'lodash';




function formatObjectAsDotpath(obj, parentKey = '', result = {}, dropNulls = false) {
  Object.keys(obj).forEach(key => {
    const newKey = parentKey ? `${parentKey}.${key}` : key;
    if (obj[key] !== undefined && typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
      formatObjectAsDotpath(obj[key], newKey, result, dropNulls);
    } else {
      if (!dropNulls || obj[key]) {
        result[newKey] = obj[key];
      }
    }
  });
  return result;
}


function deepCopy(obj) {
    return JSON.parse(JSON.stringify(obj));
}



function deepObjectFromDotPath(dotPathObject) {
  const result = {};
  Object.keys(dotPathObject).forEach(dotPath => {
    _.set(result, dotPath, dotPathObject[dotPath]);
  });
  return result;
}

function deepUpdate(target, updates) {
    Object.keys(updates).forEach(key => {
      if (_.isObject(updates[key]) && !Array.isArray(updates[key])) {
        // If the key represents an object and isn't in the target, initialize it
        if (!target[key]) target[key] = {};
        // Recursively update/merge the object
        deepUpdate(target[key], updates[key]);
      } else {
        // Directly set/update the value
        _.set(target, key, updates[key]);
      }
  })
}


/**
 * Unwind an object to a dotpath
 * @param obj {object} the nested object to unwind to a dotpath
 * @param path
 * @param result {object} the result object to store the unwound dotpath
 * @returns {{}}
 */
function unwindToDotpath(obj, path = '', result = {}) {
    Object.keys(obj).forEach(key => {
        const fullPath = path ? `${path}.${key}` : key;
        if (obj[key] !== null && typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
            unwindToDotpath(obj[key], fullPath, result);
        } else {
            result[fullPath] = obj[key];
        }
    });
    return result;
}



function prefixObjectKeys(obj, prefix){
    let newObj = {}
    Object.keys(obj).forEach(key => {
        newObj[`${prefix}.${key}`] = obj[key]
    });
    return newObj
}



export {deepCopy, formatObjectAsDotpath, deepUpdate, deepObjectFromDotPath, unwindToDotpath, prefixObjectKeys}